import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'
import { PageTitle } from '../../components'

const GrigorovichevaPrepravkaView = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <div className="jumbotron">
                        <h1 className="display-4">ГРИГОРОВИЧЕВА ПРЕПРАВКА  </h1>
                        <p className="lead">НА „ИСТОРИЯ СЛАВЯНОБЪЛГАРСКА“ (ЗМЕЕВО, 1839)</p>
                    </div>
                    <p>
                        Ръкописът, който днес се съхранява в Русия, се появява в научните описи с различни „работни" заглавия.
                        Най-популярните сред тях са:
                    </p>
                    <ul>

                        <li><em>„Григоровичева преправка на Паисиевата история"</em> (Иванов 1914: LVIII);</li>
                        <li><em>„Григоровичева преработка"</em> (Стоянов 1962: 583);</li>
                        <li><em>„Григоровичева преправка – 1839"</em> (Стоянов 1966: 70).</li>
                    </ul>

                    <p>
                        В състоянието, в което е открит, с откъснати начални и крайни листове, ръкописът не съдържа нито бележки от
                        преписвача, нито приписки, които да свидетелстват за времето и мястото на възникването му. Няма данни и за
                        преписвача.  Датировката се определя условно, по приписка, която документира смъртта на турския султан Махмуд II
                        през 1839 г. По тези косвени данни ръкописът се допуска, че Григоровичевата преправка ще да е съставена около (или
                        след) 1839 г. (Иванов 1914: LVIII).
                    </p>
                    <p>
                        Оригиналната ръкописна книга от фонда на Българската възрожденска „Паисиада" е открита от руския славист Виктор
                        Григорович по време на обиколката му на Балканския полуостров през 1844 – 1845 г., затова и е наречена
                        „Григоровичева преправка". При завръщането си руският професор отнася ръкописа със себе си в Русия. В тази връзка е
                        важно да се подчертае, че Григоровичевата преправка е <strong>само една от немалкото „похитени" от Русия български
                            ръкописни книги от „Паисиада"</strong> (такива са и Зотовият, и Жеравненският преписи, също и Спиридоновата
                        история, също и ръкопис, който в научната литература се описва като Хилфердингов препис и др.). Цитираните ръкописи
                        са „отвлечени" през деветнадесети век от изтъкнати руски професори и са внесени в Русия, за да служат на
                        академичните ѝ потреби. Заради обективността на научната оценка, трябва да се изтъкне и фактът, че руската
                        експанзия от XIX век, насочена към „похищаване" на ръкописи от „Паисиада", има и добрите си страни, защото по онова
                        време у нас все още няма български учени, които биха могли да оценят ръкописното наследие на „Паисиада". Резултатът
                        от руската експанзия води и до съхраняването на ценни ръкописи, чиято съдба в противен случай вероятно би останала
                        неизвестна за нас днес.
                    </p>
                    <p>
                        Григоровичевата преправка става факт на научното мислене чрез публикация на А. Викторов, а подробностите за това са
                        описани от Б. Ангелов (Ангелов 1966: 73). Всъщност първото задълбочено проучване на ръкописа е направено от руския
                        учен П. А. Лавров в студията му „Одна из переделок „Истории славяноболгарской" йеромонаха Паисия, сохранившияся в
                        рукописи № 1731 собрания проф. Григоровича" (Лавров 1895: 242 –263). Руският учен представя ръкописа като съдържащ
                        фрагменти от „История славянобългарска", вписани между л.л. 5а и 67б. В ръкописа е писано с черно мастило, без
                        украсяване. От Паисиевата книга са заети и преработени двата предговора, разделът за славянските първоучители,
                        имената на българските светии. Ръкописът съдържа и характерния за преправките от родослова на Компилативната
                        редакция на Рилската преправка от 1825 г. раздел за времето на второто разорение на България, също и за България,
                        която е разделена на четири части. По съдържание Григоровичевата преправка е твърде близка до Втора Харитонова
                        преправка (Змеево, 1831), но езикът ѝ е онароднен и по това се отличава от Харитоновия черковнославянски език
                        (Лавров 1895: 252 – 263). Цитираното изследването на Лавров е приносно за Паисиезнанието, защото в него са
                        публикувани и значителни фрагменти от автентичната Григоровичева преправка. 
                    </p>
                    <p>
                        У нас научен интерес към Григоровичевата преправка проявява Боню Ст. Ангелов, който чрез палеографски анализ
                        доказва, че  Старозагорската и Григоровичевата преправки са дело на един и същи книжовник (Ангелов 1966: 70 – 73). 
                        За езиково сходство между двата ръкописа свидетелства и публикация на Ил. Тодоров от (Тодоров 1982: 45 – 47).
                    </p>
                    <p>
                        Науката не разполага с данни, дали Григоровичевата преправка дава последващи родословни разклонения.
                    </p>
                    <p>
                        Днес Григоровичевата преправка се пази в Руската държавна библиотека в Москва. Сигнатурата, под която е заведен
                        ръкописът, е: Архива на Григоровича, ф. 87, № 1731 (М). Оригиналът не е публикуван цялостно.
                    </p>
                    <p>„Паспортът“ на Григоровичевата преправка е съставен от доц. д-в Мила Кръстева</p>
                    20.07.2018 г.
                </main>
            </div>
        </MainLayout>
    )
}

GrigorovichevaPrepravkaView.propTypes = {
    
}

export default GrigorovichevaPrepravkaView



// WEBPACK FOOTER //
// ./src/views/GrigorovichevaPrepravka/index.js